<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
    <path
      d="M6 0C9.31371 0 12 2.68629 12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0ZM8.77637 4.27637C9.4607 3.58433 8.41542 2.53905 7.72363 3.22363L6.00195 4.95312L4.27148 3.22363C3.58716 2.5393 2.53453 3.58458 3.22656 4.27637L4.94824 5.99805L3.22656 7.72852C2.53453 8.41284 3.58716 9.46548 4.27148 8.77344L6.00195 7.05176L7.72363 8.77344C8.41567 9.46548 9.46095 8.41284 8.77637 7.72852L7.04688 5.99805L8.77637 4.27637Z"
      fill="white"
    />
  </svg>
</template>
